const inventoryApiEndpoint = 'https://api.defenderwholesale.com/api/';

var unavailableVariants = [];
var availabilityLoaded = false;
var lastSelected = {
  variant: false,
  selector: '',
  element: false
};

function applyLocationAvailability(variants)
{
  $.ajax({
    url: inventoryApiEndpoint + 'available', 
    method: 'get',
    async: false,
    data: {'ids': variants.map(v => v.id), 'location': 'warehouse'},
    success(data) {
      unavailableVariants = [];
      data.availability.forEach(availability => {
        variants.forEach(v => {
          if(availability.variant_id == v.id) {
            v.available = availability.available;
            if(!v.available) {
              unavailableVariants.push(parseInt(v.id));
            }
          }
        })
      });

      availabilityLoaded = true;
    }
  });
}

function getLocationInventory(variantId, defaultQuantity, location)
{
  if(!location) location = 'warehouse';
  let quantity = 0;
  $.ajax({
    url: inventoryApiEndpoint + 'inventory', 
    method: 'get',
    async: false,
    data: {'ids': [variantId], 'location': location},
    success(data) {
      console.log('data', data);
      quantity = location == 'warehouse' ? data.inventory[0].warehouse_available :
        data.inventory[0].wholesale_available;
    },
    error() {
        if(defaultQuantity) 
            quantity = defaultQuantity;
    }
  });
  return quantity;
}

function getLocationInventories(variantIds, defaultQuantity)
{
  if(!Array.isArray(variantIds))
    variantIds = [variantIds];

  let quantity = 0;
  $.ajax({
    url: inventoryApiEndpoint + 'inventory', 
    method: 'get',
    async: false,
    data: {'ids': variantIds, 'location': 'warehouse'},
    success(data) {
      quantity = data.inventory[0].warehouse_available;
    },
    error() {
        if(defaultQuantity) 
            quantity = defaultQuantity;
    }
  });
  return quantity;
}